import { gql } from 'graphql-tag'
import { fragmentGlobalDataCurrency } from '../../../core/data-layer/global-data/fragments'

export default gql`
    ${fragmentGlobalDataCurrency}
    fragment PaymentsPaymentMethodExtraFieldsFragment on PaymentsPaymentMethod {
        sys {
            id
        }
        processingCurrencyCollection(limit: 50) {
            items {
                ... on GlobalDataCurrency {
                    ...GlobalDataCurrencyFragment
                }
            }
        }
        processingCurrencyAll
        processingCurrencyInfo
        settlementCurrencyCollection(limit: 50) {
            items {
                ... on GlobalDataCurrency {
                    ...GlobalDataCurrencyFragment
                }
            }
        }
    }
`
